
import { Link } from 'react-router-dom';
import { activityStats } from '../../collectionsData';

const ActivityStats = () => {

    const handleButtonClick = (e, index) => {
        e.preventDefault();
        if(e.target.getAttribute("mode") === "more"){
            e.target.setAttribute("mode", "less");
            e.target.innerHTML = "Less -";
            document.getElementById(`activity_card_details_${index}`).style.display = "flex";
        }
        else{
            e.target.setAttribute("mode", "more");
            e.target.innerHTML = "More +";
            document.getElementById(`activity_card_details_${index}`).style.display = "none";
        }
    }

    return(
        <div className="bg-[white] dark:bg-dark-content-bg dark:text-white px-[5vw] md:px-10  transition-colors duration-300 ease-in-out">
            <div className="max-w-[1300px] mx-auto px-4 pb-32 pt-6">
                <div className='flex justify-between max-w-[200px] w-full mb-6'>
                    <div className='flex justify-between max-w-[110px] w-full text-lg px-5 py-2 rounded-lg bg-main text-white'>
                        <p>Sales</p>
                        <button>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                        </button>
                    </div>
                    <button className='bg-transparent'>
                        Clear All
                    </button>
                </div>

                <div className="hidden lg:grid lg:grid-cols-custom2 gap-4 border-b-[1px] border-gray-300 dark:border-gray-700 mb-4 py-[30px]">
                <h3 className='text-xs sm:text-sm md:text-base lg:text-lg leading-36px text-bold font-[500]'>
                        Item
                    </h3>
                    <h3 className='text-xs sm:text-sm md:text-base lg:text-lg leading-36px text-bold font-[500] text-center'>
                        Price
                    </h3>
                    <h3 className='text-xs sm:text-sm md:text-base lg:text-lg leading-36px text-bold font-[500] text-center'>
                        Quantity
                    </h3>
                    <h3 className='text-xs sm:text-sm md:text-base lg:text-lg leading-36px text-bold font-[500] text-center'>
                        From
                    </h3>
                    <h3 className='text-xs sm:text-sm md:text-base lg:text-lg leading-36px text-bold font-[500] text-center'>
                        To
                    </h3>
                    <h3 className='text-xs sm:text-sm md:text-base lg:text-lg leading-36px text-bold font-[500] text-center'>
                        Time
                    </h3>
                </div>

                {activityStats.map((item, index) => {
                    return(
                        <Link to = {`/collection/${item.id}`}>
                            <div className="hidden lg:grid lg:grid-cols-custom2 gap-x-2 md:gap-x-4 border-b-[1px] border-gray-300 dark:border-gray-700 py-4 px-3 collection_card_animb hover:shadow-shadow5"> 
                                <div className="flex justify-between items-center w-full justify-self-center self-center">
                                    <p className='hidden sm:flex text-xs sm:text-sm md:text-base lg:text-lg leading-36px justify-self-center self-center text-center mr-2 md:mr-4  flex items-center'>
                                        <svg xmlns="http://www.w3.org/2000/svg" className = 'mr-2' fill = 'currentColor' width='15px' height='15px' viewBox="0 0 576 512">
                                            <path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"/>
                                        </svg>
                                        <span>Sale</span>
                                    </p>
                                    <img src = {item.image} alt = 'collectioncard' className="w-1/2 md:w-full max-w-[50px] md:max-w-100px collection_card_image mr-2 md:mr-4"/>
                                    <div className='flex flex-col'>
                                        <p className='text-xs sm:text-sm md:text-base text-slate-400 font-[500] whitespace-nowrap overflow-x-hidden'>
                                            {item.title}
                                        </p>
                                        <p className='text-xs sm:text-sm md:text-base font-[500] whitespace-nowrap overflow-x-hidden'>
                                            {item.description}
                                        </p>
                                    </div>
                                </div>
                                <div className='flex flex-col justify-center items-center'>
                                    <p className='text-xs sm:text-sm md:text-base justify-self-center self-center'>
                                        {item.ethprice}
                                    </p>
                                    <p className='text-[0.6rem] sm:text-xs md:text-sm lg:text-base text-slate-400 justify-self-center self-center'>
                                        ${item.usdprice}
                                    </p>
                                </div>
                                <p className='text-xs sm:text-sm md:text-base font-[500] justify-self-center self-center'>
                                    {item.quantity}
                                </p>
                                <p className='text-xs sm:text-sm md:text-base font-[500] text-main justify-self-center self-center'>
                                    {item.from}
                                </p>
                                <p className='text-xs sm:text-sm md:text-base font-[500] text-main justify-self-center self-center'>
                                    {item.to}
                                </p>
                                <p className='text-xs sm:text-sm md:text-base font-[500] text-main justify-self-center self-center'>
                                    {item.time}
                                </p>
                            </div>

                            <div className='block lg:hidden border-b-[1px] pt-6 border-slate-500 px-3 collection_card_anim'>

                                <div className='flex justify-between w-full pb-6'>
                                    <div className="flex lg:justify-center items-center max-w-[200px] w-full">
                                        <img src = {item.image} alt = 'collectioncard' className="w-1/2 md:w-full max-w-[50px] md:max-w-100px collection_card_image mr-2 md:mr-4"/>
                                        <div className='flex flex-col items-start'>
                                            <p className='text-xs sm:text-sm md:text-base text-slate-400 font-[500] whitespace-nowrap overflow-x-hidden'>
                                                {item.title}
                                            </p>
                                            <p className='text-xs sm:text-sm md:text-base font-[500] whitespace-nowrap overflow-x-hidden'>
                                                {item.description}
                                            </p>
                                            <button className='text-sm text-slate-500' mode = "more" onClick = {(e) => handleButtonClick(e, index)}>
                                                More +
                                            </button>
                                        </div>
                                    </div>

                                    <div className='flex flex-col justify-center'>
                                        <p className='text-xs sm:text-sm md:text-base font-[500] justify-self-center self-center text-slate-400'>
                                            Sale
                                        </p>
                                        <p className='text-xs sm:text-sm md:text-base font-[500] justify-self-center self-center'>
                                            {item.ethprice}
                                        </p>
                                        <p className='text-xs sm:text-sm md:text-base font-[500] justify-self-center self-center text-slate-400'>
                                            {item.time}
                                        </p> 
                                    </div>

                                </div>

                                <div className='hidden items-center justify-between mx-5 pt-4 pb-4 border-t-[1px] border-slate-500' id = {`activity_card_details_${index}`}>
                                    
                                    <div className='flex flex-col'>
                                        <p className='text-xs sm:text-sm md:text-base font-[500] text-slate-400'>
                                            USD Price
                                        </p>
                                        <p className='text-xs sm:text-sm md:text-base font-[500] justify-self-center self-center'>
                                            {item.usdprice}
                                        </p>
                                    </div>

                                    <div className='flex flex-col'>
                                        <p className='text-xs sm:text-sm md:text-base font-[500] text-slate-400'>
                                            Quantity
                                        </p>
                                        <p className='text-xs sm:text-sm md:text-base font-[500]'>
                                            {item.quantity}
                                        </p>
                                    </div>

                                    <div className='flex flex-col'>
                                        <p className='text-xs sm:text-sm md:text-base font-[500] text-slate-400'>
                                            From
                                        </p>
                                        <p className='text-xs sm:text-sm md:text-base font-[500] text-main'>
                                            {item.from}
                                        </p>
                                    </div>
                                    
                                    <div className='flex flex-col'>
                                        <p className='text-xs sm:text-sm md:text-base font-[500] text-slate-400'>
                                            To
                                        </p>
                                        <p className='text-xs sm:text-sm md:text-base font-[500] text-main'>
                                            {item.to}
                                        </p>
                                    </div>

                                </div>

                            </div>

                        </Link>
                    )
                })}


            </div>
        </div>
    )

}

export default ActivityStats;